@if(isLoading){
 <div class="welcome">
  <div class="row">
    <div class="column" style="padding: 5%">
      <mat-spinner [diameter]="150"></mat-spinner>
    </div>
  </div>
</div>
}
  
<div class="linkCardPage">
    <div class="container py-0" style="max-width: 1022px;">
        <img class="w-100 d-none d-md-flex rounded" alt="gm business card image" [src]="desktopImg">
        <img class="w-100 d-flex d-md-none rounded" [src]="mobileImg" alt="gm business card image">
    </div>
    <form [formGroup]="cardForm" (ngSubmit)="onSubmit()">
        <div class="container py-0 d-flex flex-column gap-64-48sm" style="max-width: 1022px;">
            <div class="linkCardTitle titleSpacing">Add your GM Business™ Mastercard<span class="registered">®</span> to
                your account</div>
            <div class="d-flex flex-column flex-md-row gap-4 mb-4">
                <div class="gb-input col">
                    <input required class="form-control stat-input-field" type="text" formControlName="nameOnCard" id="nameOnCard"
                        placeholder="" data-dtm="add gm business mastercard" />
                    <label class="gb-input-label" for="nameOnCard"
                        [ngClass]="{'text-label':cardForm.get('nameOnCard')?.value !== ''}">Name on card</label>
                    <div class="text-danger ps-2"
                        *ngIf="cardForm.get('nameOnCard')?.invalid && cardForm.get('nameOnCard')?.touched">
                        Name required
                    </div>
                </div>
                <div class="gb-input col">
                    <input required class="form-control stat-input-field" type="text" formControlName="cardNumber" id="cardNumber"
                        maxlength="4" data-dtm="add gm business mastercard" />
                    <label class="gb-input-label" for="cardNumber"
                        [ngClass]="{'text-label':cardForm.get('cardNumber')?.value !== ''}">Last 4 digits of card
                        number</label>
                    <div class="text-danger ps-2"
                        *ngIf="cardForm.get('cardNumber')?.invalid && cardForm.get('cardNumber')?.touched">
                        Last 4 digits of card number required
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row gap-0sm-15">

                <div class="gb-input col">
                    <input required class="form-control stat-input-field" type="text" formControlName="zipCode" id="zipCode"
                        maxlength="5" data-dtm="add gm business mastercard" />
                    <label class="gb-input-label" for="zipCode"
                        [ngClass]="{'text-label' : cardForm.get('zipCode')?.value !== ''}">Billing ZIP Code</label>
                    <div class="text-danger ps-2"
                        *ngIf="cardForm.get('zipCode')?.invalid && cardForm.get('zipCode')?.touched">
                        ZIP Code required
                    </div>
                </div>
                <div class="col"></div>
            </div>
            <div class="d-flex me-md-auto button-margin">
                <button [disabled]="cardForm.invalid || isLoading" type="submit" data-dtm="add gm business mastercard"
                    class=" gb-primary-button primary-button stat-button-link"
                    [ngClass]="{'disabled-button' : (cardForm.invalid || isLoading) }">Submit
                </button>
            </div>
            @if(errorFlag){
            <div class="pt-3 text-danger">{{error}}</div>
            }
        </div>
    </form>
</div>